var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgManuallySubtractedPoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    "aria-hidden": "true",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1446 0H2.85538C1.28 0 0 1.28 0 2.85538V13.1405C0 14.7159 1.28 15.9959 2.85538 15.9959H13.1405C14.7159 15.9959 15.9959 14.7159 15.9959 13.1405V2.85538C15.9959 1.28 14.7159 0 13.1405 0H13.1446ZM10.8595 8.57026H5.14462C4.82872 8.57026 4.57436 8.3159 4.57436 8C4.57436 7.6841 4.82872 7.42974 5.14462 7.42974H10.8595C11.1754 7.42974 11.4297 7.6841 11.4297 8C11.4297 8.3159 11.1754 8.57026 10.8595 8.57026Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManuallySubtractedPoints);
export default __webpack_public_path__ + "static/media/manually-subtracted-points.43043dbddd537883a43fca183eed861e.svg";
export { ForwardRef as ReactComponent };